import React from 'react';
import { Link } from 'react-router-dom';
import './PrivacyPolicy.css';
import { FaArrowLeft } from 'react-icons/fa';

const PrivacyPolicy = () => {
  return (    <div className="privacy-page">
      <div className="privacy-container">
        <Link to="/" className="back-button">
          <FaArrowLeft /> Back to Home
        </Link>
        
        <div className="privacy-header">
          <h1 className="privacy-title">Privacy Policy</h1>
          <p className="privacy-subtitle">Last updated: June 24, 2025</p>
        </div>

        <div className="privacy-content">
          <section className="privacy-section">
            <h2>Information We Collect</h2>
            <p>
              At Aesthetic AI Receptionist, we collect information to provide better services to our users. 
              This includes information you provide directly, such as your name, email address, phone number, 
              and practice details when you sign up for our service.
            </p>
          </section>

          <section className="privacy-section">
            <h2>How We Use Your Information</h2>
            <p>We use the information we collect to:</p>
            <ul>
              <li>Provide and maintain our AI receptionist services</li>
              <li>Process appointments and manage patient communications</li>
              <li>Improve our service quality and user experience</li>
              <li>Send you important updates about your service</li>
              <li>Comply with legal obligations and industry regulations</li>
            </ul>
          </section>

          <section className="privacy-section">
            <h2>HIPAA Compliance</h2>
            <p>
              As a service provider to healthcare practices, we are committed to maintaining HIPAA compliance. 
              All patient health information (PHI) is handled according to HIPAA standards and regulations. 
              We have implemented appropriate administrative, physical, and technical safeguards to protect PHI.
            </p>
          </section>

          <section className="privacy-section">
            <h2>Data Security</h2>
            <p>
              We implement industry-standard security measures to protect your information, including:
            </p>
            <ul>
              <li>End-to-end encryption for all data transmission</li>
              <li>Secure data storage with regular backups</li>
              <li>Access controls and user authentication</li>
              <li>Regular security audits and monitoring</li>
              <li>Staff training on data protection practices</li>
            </ul>
          </section>

          <section className="privacy-section">
            <h2>Information Sharing</h2>
            <p>
              We do not sell, trade, or otherwise transfer your personal information to third parties without 
              your consent, except as described in this policy or as required by law. We may share information 
              with trusted service providers who assist in operating our service, provided they agree to keep 
              this information confidential.
            </p>
          </section>

          <section className="privacy-section">
            <h2>Your Rights</h2>
            <p>You have the right to:</p>
            <ul>
              <li>Access and review your personal information</li>
              <li>Request corrections to inaccurate information</li>
              <li>Request deletion of your personal information</li>
              <li>Opt-out of certain communications</li>
              <li>File a complaint with supervisory authorities</li>
            </ul>
          </section>

          <section className="privacy-section">
            <h2>Contact Us</h2>
            <p>
              If you have any questions about this Privacy Policy or our data practices, please contact us:
            </p>
            <div className="contact-info">
              <p><strong>Email:</strong> privacy@aesthetic-ai.com</p>
              <p><strong>Phone:</strong> (323) 283-8368</p>
              <p><strong>Address:</strong> 123 Healthcare Blvd, Suite 100, Medical City, CA 90210</p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
